var $ = jQuery;

$(document).on('ready', function(){
    $(document).on('mouseover', '.property-card', function() {
        var index =  $(this).attr('index');
        $('.marker-'+index).addClass('show');
    })

    $(document).on('mouseleave', '.property-card', function() {
        var index =  $(this).attr('index');
        $('.marker-'+index).removeClass('show');
    })

    $(document).on('click', '.leaflet-marker-icon', function() {
        $('.leaflet-marker-icon').each(function(index) {
            $(this).removeClass('show');
        })
        $(this).addClass('show');
        var classes = $(this).attr("class").split(/\s+/);
        var markerClass = classes[1];
        var split_string = markerClass.split("-");
        var markerIndex = split_string[1];
        $('html, body').scrollTop($(".property-card[index='" +markerIndex+ "'").offset().top);
    })
})